module.exports = __webpack_public_path__ + "img/ll.c3cf078d.png";